module.exports = __webpack_public_path__ + "img/hero-shape-1.833ccedb.png";